import { useTranslation } from 'next-i18next'
import Image from 'next/future/image'
import Link from 'next/link'

export default function PluginAboutManufacturer ({ plugin }) {
  const { t } = useTranslation('plugins')

  return (
    <div>
      <h2 className="text-dark fw-bold fs-2 mb-4 mb-lg-5">{t('detail.seller.title')}</h2>
      <div className="bg-light p-4  p-md-5">
        <div className="row g-4 justify-content-sm-between">
          <div className="col-12 col-sm-auto">
            <div className="d-flex align-items-center">
              {plugin.company.logo.url && (
                <Image alt=""
                  src={plugin.company.logo.url}
                  width={plugin.company.logo.width}
                  height={plugin.company.logo.height}
                  className="img-fluid"
                  style={{ width: '60px', height: 'auto' }}
                />
              )}
              <Link href={`/seller/${plugin.company.slug}`}>
                <a className="ms-3">{plugin.company.name}</a>
              </Link>
            </div>
          </div>
          <div className="col-12 d-sm-none">
            <hr />
          </div>
          <div className="col-12 col-sm-auto text-center">
            <div className="row gap-sm-4 gap-md-5">
              <div className="col-6 col-sm-auto">
                <strong>{plugin.company.product_count}</strong>
                <p className="m-0"><small>{t('detail.seller.plugins')}</small></p>
              </div>
              <div className="col-6 col-sm-auto">
                <div className="d-flex justify-content-center align-items-center">
                  <Image alt=""
                    src="/images/icons/star-default.png"
                    width={20}
                    height={20}
                    className="me-2"
                  />
                  <strong>{plugin.company.rating}</strong>
                </div>
                <p className="m-0">
                  <small>{t('detail.seller.average_rating')}</small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
